export const getTemplateHeadings = (lang) => ({
  PDF: lang[10],
  Apps: lang[13],
  Business: lang[18],
  Coupon: lang[14],
  Event: lang[16],
  FeedBack: lang[21],
  Images: lang[17],
  "Wi-Fi": lang[22],
  Website: lang[12],
  "List Of Links": lang[11],
  Menu: lang[19],
  MP3: lang[20],
  Playlist: lang[15],
  Video: lang[23],
  vCard: lang[24],
  Pets: lang[25],
  Retail: lang[26],
  Tourism: lang[27],
  "Restaurants and Cafes": lang[28],
  Education: lang[29],
  Medical: lang[30],
  "Government Services": lang[31],
  "Automotive Industry": lang[32],
  "Sports and Fitness": lang[33],
  IT: lang[34],
  Cleaning: lang[35],
  "E commerce": lang[36],
  "Home Services": lang[237],
  Music: lang[38],
  "Energy and Utilities": lang[39],
  "Freelancing and Gig Economy": lang[40],
  Gaming: lang[41],
  "Publishing and Media": lang[42],
  "Personal Care and Beauty": lang[43],
  "Security Services": lang[44],
  "Translation and Language Services": lang[45],
  "Non-Profit Organizations": lang[46],
  Logistics: lang[47],
  "Finance and Banking": lang[48],
  "CV": lang[49],
  "Cultural Institution": lang[50],
  "Real Estate": lang[51],
  "Learning and Development": lang[52],
});